"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderBase = exports.paramsToArray = void 0;
var dispose_tree_1 = require("@tencent/dispose-tree");
var error_messages_1 = require("../constants/error-messages");
var instantiation_1 = require("./instantiation");
var instantiation_hook_1 = require("./instantiation-hook");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function paramsToArray(params) {
    if (Array.isArray(params)) {
        return params;
    }
    return [params];
}
exports.paramsToArray = paramsToArray;
/**
 * 异步loader的通用逻辑，包括解析Ioc容器设置、初始化实例、销毁实例
 */
var LoaderBase = /** @class */ (function () {
    function LoaderBase(instantiationService) {
        this.instantiationHook = new instantiation_hook_1.InstantiationHook();
        this.selfInstantiationService = instantiationService;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    LoaderBase.prototype.createInstance = function (ctor, allParams) {
        if (this.instance) {
            return this.instance;
        }
        var innerInstantionService = this.loaderInstantiationService();
        var instance = innerInstantionService.createInstance.apply(innerInstantionService, __spread([ctor], allParams));
        this.executeHooks(instance, instantiation_1.IInstantiationHookPoint.POST_CONSTRUCTOR);
        this.instance = instance;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dispose_tree_1.tryToMarkDispose(instance);
        return instance;
    };
    /**
       * 根据一定的优先级获取当前loader的InstantiationService
       */
    LoaderBase.prototype.loaderInstantiationService = function () {
        var _this = this;
        // 优先使用继承者提供的Ioc容器，其次使用静态容器
        var manuallInstantion = this.getInstantion() || LoaderBase.staticInstantiationService;
        // 校验设置的Ioc容器是否合法
        if (manuallInstantion && manuallInstantion !== this.selfInstantiationService) {
            // 检查是否为孤儿节点
            var orphanInstantiationService_1 = true;
            manuallInstantion.getHierarchyNode().walkUp(function (instantiationNode) {
                // 可达性验证
                if (orphanInstantiationService_1 && instantiationNode === _this.selfInstantiationService) {
                    orphanInstantiationService_1 = false;
                }
            });
            // Ioc容器为孤儿节点抛出异常
            if (orphanInstantiationService_1) {
                throw new Error(error_messages_1.LOADER_BASE_ORPHAN_INSTANTIATION);
            }
        }
        var instantionService = manuallInstantion || this.selfInstantiationService;
        return instantionService;
    };
    /**
     * 可由继承者提供默认的InstantiationService
     */
    LoaderBase.prototype.getInstantion = function () {
        return null;
    };
    LoaderBase.prototype.addHook = function (hookPoint, callback) {
        this.instantiationHook.addHook(hookPoint, callback);
    };
    LoaderBase.prototype.executeHooks = function (instance, point) {
        this.instantiationHook.executeHooks(instance, point);
    };
    /**
     * 可静态的设置InstantiationService
     */
    LoaderBase.initStaticInstantiationService = function (instantiation) {
        if (!LoaderBase.staticInstantiationService) {
            LoaderBase.staticInstantiationService = instantiation;
        }
        else {
            throw new Error(error_messages_1.LOADER_BASE_STATIC_INSTANTIATION);
        }
    };
    LoaderBase.prototype.dispose = function (trace) {
        var _a, _b;
        if (!this.instance) {
            return;
        }
        // 如果loader加载的实例需要清理，则调用它的dipose方法
        if (dispose_tree_1.isDisposable(this.instance)) {
            trace && trace.branch((((_b = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) || '') + "instance");
            this.instance.dispose(trace);
        }
        this.instance = null;
    };
    return LoaderBase;
}());
exports.LoaderBase = LoaderBase;
//# sourceMappingURL=loader-base.js.map